import { Fragment, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";

export const DropDownMonthSelection = ({
  onSelected,
  startFromMonthLuxtonDatetime,
  defaultSelect = null,
  displayTheLast = 12,
  useStartDate = false,
}) => {
  const [selected, setSelected] = useState(defaultSelect);
  const [monthListOptions, setMonthListOptions] = useState(null);

  useEffect(() => {
    if (monthListOptions === null) {
      var buildMonthList = [];
      for (let i = 0; i < displayTheLast; i++) {
        buildMonthList.push(
          startFromMonthLuxtonDatetime.minus({
            months: i,
          }),
        );
      }

      if (useStartDate && selected === null && defaultSelect === null) {
        setSelected(buildMonthList.at(0));
        onSelected(buildMonthList.at(0));
      }

      setMonthListOptions(buildMonthList);
    }
  }, []);

  const onClickSelectMonth = (option) => {
    setSelected(option);
    onSelected(option);
  };

  if (monthListOptions === null) return null;

  return (
    <Fragment>
      <Dropdown>
        <Dropdown.Toggle
          className={"shift-table-dropdown"}
          variant={"success"}
          id={"dropdown-basic"}
        >
          {selected !== null ? selected.toFormat("y: MMMM") : "Select Month"}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {monthListOptions.map((option, i) => (
            <Dropdown.Item key={i} onClick={() => onClickSelectMonth(option)}>
              {option.toFormat("y: MMMM")}
            </Dropdown.Item>
          ))}

          {selected !== null ? (
            <Dropdown.Item onClick={() => onClickSelectMonth(null)}>
              Remove Selection
            </Dropdown.Item>
          ) : null}
        </Dropdown.Menu>
      </Dropdown>
    </Fragment>
  );
};
